import React from 'react'
import fetch from 'isomorphic-fetch'
import LadderCharacter from '../ladder-character'
import LadderMenu from '../ladder-menu'
import CharacterTable from '../character-table'
import { Grid, Tabs, Tab, Spinner, Icon } from 'react-mdl'
import './style.css'

const modes = ['standard', 'hardcore', 'exp', 'exphardcore'];
const classes = ['overall', 'amazon', 'sorceress', 'necromancer', 'paladin', 'barbarian', 'druid', 'assassin'];
const modeNames = ['Standard', 'Hardcore', 'Exp', 'Exp Hc'];
const classNames = ['Overall', 'Ama', 'Sor', 'Nec', 'Pal', 'Bar', 'Dru', 'Asn'];

export default class Ladder extends React.Component {

    state = {
        characters: null,
        activeMode: 3,
        activeClass: 0,
        errorOccurred: false,
        invalidParams: false
    }

    constructor(props) {
        super(props);

        var modeID = modes.indexOf(this.props.params.mode);
        var classID = classes.indexOf(this.props.params.class);

        if(modeID < 0 || classID < 0) {
            this.state = {
                invalidParams: true
            };
        }
        else {
            this.state = {
                activeMode: modeID,
                activeClass: classID
            };
        }
    }

    componentDidUpdate() {

      if(!this.state.characters && this.isAllowed() && !this.state.errorOccurred) {
          this.loadCharacters();
      }
    }

    componentDidMount() {
      document.title = "Current ladder";
      this.loadCharacters();
    }

    isAllowed() {
        var m = this.state.activeMode;
        var c = this.state.activeClass;
        switch(true) {
            case (m === 0 && c === 6):
            case (m === 0 && c === 7):
            case (m === 1 && c === 6):
            case (m === 1 && c === 7):
              return false;
            default:
              return true;
        }
    }

    loadCharacters() {
        fetch('https://ladder.slashdiablo.net/ladder/rankings/'+modes[this.state.activeMode]+'?class='+classes[this.state.activeClass])
        .then((response) => {
            if (response.status >= 400) {
                throw new Error("Something went terribly wrong");
            }
            return response.json();
        })
        .then((response) => {

            if(response.characters) {
                this.setState({
                    characters: response.characters,
                    errorOccurred: false
                });
            }
            else {
                this.setState({
                    characters: [],
                    errorOccurred: false
                });
            }
        })
        .catch((e) => {
            this.setState({
                errorOccurred: true
            });
        });
    }

    reload(state) {
        if(state.type === 'mode') {
            window.location.href = `/${modes[state.id]}/${classes[this.state.activeClass]}`
        }
        else if(state.type === 'class') {
            window.location.href = `/${modes[this.state.activeMode]}/${classes[state.id]}`
        }
    }

    render() {

        if(this.state.invalidParams) {
            return (
                <div className="broadcast">
                    <Icon name="power" />
                    <h1 className="broadcast-text">Invalid mode or class, please try again.</h1>
                </div>
            );
        }

        if(this.state.errorOccurred) {
            return (
                <div className="broadcast">
                    <Icon name="power" />
                    <h1 className="broadcast-text">Something went terribly wrong, please try again.</h1>
                </div>
            );
        }

        if(!this.state.characters && this.isAllowed()) {
            return (
                <div className="broadcast">
                    <Spinner />
                    <h1 className="broadcast-text">Crunching the numbers just for you.</h1>
                </div>
            );
        }

        return (
            <div>
                <LadderMenu/>
                <Tabs activeTab={this.state.activeMode} onChange={(modeId) => this.reload({type: 'mode', id: modeId})} ripple>
                    {modeNames.map((tabName) => {
                        if ((this.state.activeClass === classNames.indexOf("Dru") || this.state.activeClass === classNames.indexOf("Asn")) && ["Standard", "Hardcore"].includes(tabName)) return <Tab key={tabName} className='mdl-tabs__tab disabled-tab'>{tabName}</Tab>;
                        return <Tab key={tabName}>{tabName}</Tab>;
                    })}
                </Tabs>
                <Tabs activeTab={this.state.activeClass} onChange={(classId) => this.reload({type: 'class', id: classId})} ripple>
                   {classNames.map((tabName) => {
                       if ((this.state.activeMode === modeNames.indexOf("Standard") || this.state.activeMode === modeNames.indexOf("Hardcore")) && ["Dru", "Asn"].includes(tabName)) return <Tab key={tabName} className='mdl-tabs__tab disabled-tab'>{tabName}</Tab>;
                       return <Tab key={tabName}>{tabName}</Tab>;
                   })}
                </Tabs>
                <section className="content">
                    { this.isAllowed() ?
                        <Grid className="ladder-characters">
                            { this.state.characters.slice(0,6).map((character) =>
                                <LadderCharacter key={(character.type+character.name)} data={character} />
                            )}
                            <CharacterTable characters={this.state.characters.slice(6, 100)}/>
                        </Grid>
                        :
                        <div className="broadcast">
                            <Icon name="error_outline" />
                            <h1 className="broadcast-text">This class does not exist on classic.</h1>
                        </div>
                    }
                </section>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/ladder/index.jsx
 **/